/* eslint-disable no-param-reassign, unicorn/no-array-callback-reference */
import Vue from 'vue';
import useVueCompositionApi from '@/js/common/plugins/use-vue-composition-api';
import GiftCertificatesBanner from './GiftCertificatesBanner.vue';
import shouldHideGiftCertificatesBanner from './shouldHideGiftCertificatesBanner';

useVueCompositionApi();

const SELECTORS = {
  GIFT_CERTIFICATES_BANNER: '.js-gift-certificates-banner',
  GIFT_CERTIFICATES_BANNER_WRAPPER: '.js-gift-certificates-banner-wrapper',
  OLD_TOUR_USUALLY_INCLUDES_BANNER: '.js-old-tour-usually-includes-banner',
  BANNER_PARENT: '.b-tour-components, .tourUsuallyIncludes, .serpHotelCard--gift-certificates',
};

const CLASSES = {
  GIFT_CERTIFICATES_BANNER_MODIFIER: 'b-tour-components_gift-certificates-banner',
};

function mountBanner(container) {
  if (!container || container.__vueInstance) return;
  if (shouldHideGiftCertificatesBanner()) return;
  container.__vueInstance = new Vue({
    render: (h) =>
      h(GiftCertificatesBanner, {
        props: {
          link: container?.dataset?.link,
          openInNewTab:
            container?.dataset?.openInNewTab == null
              ? true
              : !(container.dataset.openInNewTab === 'false' || container.dataset.openInNewTab === '0'),
          title: container?.dataset?.title,
          titleWrapping: container?.dataset?.titleWrapping,
          subtitle: container?.dataset?.subtitle,
          buttonText: container?.dataset?.buttonText,
          customClass: container?.dataset?.customClass,
          customClassContainer: container?.dataset?.customClassContainer,
          isSearchPage: container?.dataset?.isSearchPage === 'true',
          showDiscountBanner: container?.dataset?.showDiscountBanner === 'true',
          showCashbackBanner: container?.dataset?.showCashbackBanner === 'true',
        },
      }),
  }).$mount(container);
}

function showOldBanner() {
  document.querySelectorAll(SELECTORS.OLD_TOUR_USUALLY_INCLUDES_BANNER).forEach((oldBanner) => {
    oldBanner.style.display = '';
  });
}

function toggleGiftBannerClass(show) {
  document.querySelectorAll('.b-tour-components').forEach((element) => {
    if (element.querySelector(SELECTORS.GIFT_CERTIFICATES_BANNER_WRAPPER)) {
      if (show) {
        element.classList.add(CLASSES.GIFT_CERTIFICATES_BANNER_MODIFIER);
      } else {
        element.classList.remove(CLASSES.GIFT_CERTIFICATES_BANNER_MODIFIER);
      }
    }
  });
}

function hideBannerElements() {
  if (!shouldHideGiftCertificatesBanner()) return;

  document.querySelectorAll(SELECTORS.GIFT_CERTIFICATES_BANNER_WRAPPER).forEach((wrapper) => {
    wrapper.style.display = 'none';
  });

  document.querySelectorAll(SELECTORS.GIFT_CERTIFICATES_BANNER).forEach((container) => {
    if (container.__vueInstance) {
      container.__vueInstance.$destroy();
      delete container.__vueInstance;
    }
    const parent = container.closest(SELECTORS.BANNER_PARENT);
    if (parent && !parent.querySelector(SELECTORS.GIFT_CERTIFICATES_BANNER_WRAPPER)) {
      parent.style.display = 'none';
    } else {
      container.style.display = 'none';
    }
  });

  toggleGiftBannerClass(false);
  showOldBanner();
}

function mountAllBanners() {
  if (shouldHideGiftCertificatesBanner()) {
    hideBannerElements();
    showOldBanner();
    return;
  }

  document.querySelectorAll(SELECTORS.OLD_TOUR_USUALLY_INCLUDES_BANNER).forEach((oldBanner) => {
    oldBanner.style.display = 'none';
  });

  document.querySelectorAll(SELECTORS.GIFT_CERTIFICATES_BANNER_WRAPPER).forEach((wrapper) => {
    wrapper.style.display = '';
  });

  toggleGiftBannerClass(true);
  document.querySelectorAll(SELECTORS.GIFT_CERTIFICATES_BANNER).forEach(mountBanner);
}

function setupObserver() {
  if (window.__giftCertificatesBannerObserver) return;
  try {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          if (shouldHideGiftCertificatesBanner()) {
            hideBannerElements();
            showOldBanner();
          } else {
            mountAllBanners();
          }
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__giftCertificatesBannerObserver = observer;
  } catch {
    // Ignore errors
  }
}

function initGiftCertificatesBanner() {
  mountAllBanners();
  setupObserver();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGiftCertificatesBanner);
} else {
  initGiftCertificatesBanner();
}

export default initGiftCertificatesBanner;
